import {
    GET_MOVIE_THEATERS,
    GET_MOVIE_THEATERS_SUCCEEDED,
    ADD_CINEMA_ON_FAVORITE,
    ADD_CINEMA_ON_FAVORITE_SUCCEEDED,
    REMOVE_CINEMA_ON_FAVORITE,
    REMOVE_CINEMA_ON_FAVORITE_SUCCEEDED,
    GET_HALL_CONFIGURATION,
    GET_HALL_CONFIGURATION_SUCCEEDED,
    STORE_SELECTED_SEATS,
    STORE_SELECTED_SEATS_SUCCEEDED,
    CLEAR_HALL_CONFIGURATION,
    CLEAR_HALL_CONFIGURATION_SUCCEEDED,
    ADD_MOVIETHEATER_TO_FAVORITE,
    REMOVE_MOVIETHEATER_FROM_FAVORITE,
    GET_MOVIE_THEATERS_WITH_TICKETS,
    GET_MOVIE_THEATERS_WITH_TICKETS_SUCCEEDED,
    GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE,
    GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE_SUCCEEDED,
    GET_MOVIE_THEATERS_SEE_MORE,
    GET_MOVIE_THEATERS_SEE_MORE_SUCCEEDED,
    STORE_SELECTED_COUCH,
    STORE_SELECTED_COUCH_SUCCEEDED,
    STORE_SELECTED_TICKETS,
    STORE_SELECTED_TICKETS_SUCCEEDED,
    REMOVE_SELECTED_TICKETS,
    REMOVE_SELECTED_TICKETS_SUCCEEDED,
    CLEAR_SELECTED_SEATS_AND_COUCH
} from './types';

export const requestMovieTheaters = (payload) => ({
    type: GET_MOVIE_THEATERS,
    payload,
});

export const getMovieTheatersSucceeded = (payload) => ({
    type: GET_MOVIE_THEATERS_SUCCEEDED,
    payload,
});

export const getMovieTheatersSeeMore = (payload) => ({
    type: GET_MOVIE_THEATERS_SEE_MORE,
    payload
})

export const getMovieTheatersSeeMoreSucceeded = (payload) => ({
    type: GET_MOVIE_THEATERS_SEE_MORE_SUCCEEDED,
    payload
})

export const requestAddCinemaOnFavourite = (payload) => ({
    type: ADD_CINEMA_ON_FAVORITE,
    payload,
});

export const addCinemaOnFavouriteSucceeded = (payload) => ({
    type: ADD_CINEMA_ON_FAVORITE_SUCCEEDED,
    payload,
});

export const requestRemoveCinemaOnFavourite = (payload) => ({
    type: REMOVE_CINEMA_ON_FAVORITE,
    payload,
});

export const removeCinemaOnFavouriteSucceeded = (payload) => ({
    type: REMOVE_CINEMA_ON_FAVORITE_SUCCEEDED,
    payload,
});

export const getHallConfiguration = (payload) => ({
    type: GET_HALL_CONFIGURATION,
    payload,
});

export const getHallConfigurationSucceeded = (payload) => ({
    type: GET_HALL_CONFIGURATION_SUCCEEDED,
    payload,
});

export const storeSelectedSeats = (payload) => ({
    type: STORE_SELECTED_SEATS,
    payload
})

export const storeSelectedSeatsSucceeded = (payload) => ({
    type: STORE_SELECTED_SEATS_SUCCEEDED,
    payload
})

export const storeSelectedCouch = (payload) => ({
    type: STORE_SELECTED_COUCH,
    payload
})

export const storeSelectedCouchSucceeded = (payload) => ({
    type: STORE_SELECTED_COUCH_SUCCEEDED,
    payload
})

export const clearSelectedSeatsAndCouch = (payload) => ({
    type: CLEAR_SELECTED_SEATS_AND_COUCH,
    payload
})

export const clearHallConfiguration = (payload) => ({
    type: CLEAR_HALL_CONFIGURATION,
    payload
})

export const clearHallConfigurationSucceeded = (payload) => ({
    type: CLEAR_HALL_CONFIGURATION_SUCCEEDED,
    payload
})

export const addCinemaToFavorite = (payload) => ({
    refresh: true,
    type: ADD_MOVIETHEATER_TO_FAVORITE,
    payload
})

export const removeCinemaFromFavorite = (payload) => ({
    refresh: true,
    type: REMOVE_MOVIETHEATER_FROM_FAVORITE,
    payload
})

export const getMovieTheatersWithTickets = (payload) => ({
    type: GET_MOVIE_THEATERS_WITH_TICKETS,
    payload
})

export const getMovieTheatersWithTicketsSucceeded = (payload) => ({
    type: GET_MOVIE_THEATERS_WITH_TICKETS_SUCCEEDED,
    payload
})

export const getMovieTheatersWithTicketsSeeMore = (payload) => ({//
    type: GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE,
    payload
})

export const getMovieTheatersWithTicketsSeeMoreSucceeded = (payload) => ({
    type: GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE_SUCCEEDED,
    payload
})

export const storeSelectedTickets = (payload) => ({
    type: STORE_SELECTED_TICKETS,
    payload
})

export const storeSelectedTicketsSucceeded = (payload) => ({
    type: STORE_SELECTED_TICKETS_SUCCEEDED,
    payload
})

export const removeSelectedTickets = (payload) => ({
    type: REMOVE_SELECTED_TICKETS,
    payload
})

export const removeSelectedTicketsSucceeded = (payload) => ({
    type: REMOVE_SELECTED_TICKETS_SUCCEEDED,
    payload
})


// WEBPACK FOOTER //
// ./src/SHARED/actions/movietheaters.actions.js